


















































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppSwitch from '@/views/kyc-form/component/AppSwitch.vue'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppCheckboxGroup from '@core/components/AppCheckboxGroup.vue'
import AppForm from '@core/components/AppForm.vue'
import { Options, FormStructure } from '@master/model/structure/FormStructure'
import ThirdPartyPayor from '@master/model/kyc-form/ThirdPartyPayor'
import Budget from '@company-common/model/kyc-form/finances/Budget'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppSwitch,
    AppRadioSelection,
    AppCheckboxGroup,
    AppForm
  }
})
export default class BudgetView extends Vue {
  selectedClient = 'Client 1';
  @kycFormStore.State
  private kycForm!: KYCForm;

  @kycFormStore.State
  private computedValidationResult: any

  get sectionErrors () {
    return this.computedValidationResult.Budget || {}
  }

  get thirdPartySectionErrors () {
    const errors = this.sectionErrors.Common || []
    const finalErrors: { key: string; msg: string }[] = []
    errors.map(({ key, message }) => {
      key.map(variableName => {
        finalErrors.push({
          key: variableName,
          msg: message
        })
      })
    })
    return finalErrors
  }

  clientOptionSelected (option: string): void {
    if (option === 'Client 2' && !this.isClient2Included()) {
      window.alert('Client 2 is not included in this KYC Form. To include, go to "Client Summary" page and enable the checkbox.')
      return
    }
    this.selectedClient = option
  }

  isClient2Included () {
    return this.kycForm.client2.personalDetails.included
  }

  get sharedBudgetAttributes () {
    return this.kycForm.client1.budget
  }

  get editingClient () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.budget
    } else {
      return this.kycForm.client2.budget
    }
  }

  get thirdPartyPayor () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.thirdPartyPayor
    } else {
      return this.kycForm.client2.thirdPartyPayor
    }
  }

  get budgetSourceOfFunds (): Options<Budget> {
    return {
      key: 'budgetSourceOfFunds',
      options: [
        { label: 'Employment / Trade Income', value: 'employment' },
        { label: 'Saving (Including CPF Fund)', value: 'saving' },
        {
          label: 'Others:',
          value: 'others_1',
          others: {
            key: 'budgetOthers1',
            disabled: (budget) => !budget.budgetSourceOfFunds.includes('others_1')
          }
        },
        {
          label: 'Others:',
          value: 'others_2',
          others: {
            key: 'budgetOthers2',
            disabled: (budget) => !budget.budgetSourceOfFunds.includes('others_2')
          }
        }
      ]
    }
  }

  get budgetSourceOfWealth (): Options<Budget> {
    return {
      key: 'budgetSourceOfWealth',
      options: [
        { label: 'Employment / Trade Income', value: 'employment' },
        { label: 'Investment Income', value: 'investment' },
        { label: 'Rental Income', value: 'rental' },
        {
          label: 'Others:',
          value: 'others_3',
          others: {
            key: 'budgetOthers3',
            disabled: (budget) => !budget.budgetSourceOfWealth.includes('others_3')
          }
        }
      ]
    }
  }

  get thirdPartyPayorStructure (): FormStructure<ThirdPartyPayor> {
    return [
      {
        label: 'Name of payor',
        key: 'budgetNameOfPayor'
      },
      {
        label: 'Contact Number of payor',
        key: 'budgetContactPayor'
      },
      {
        label: 'NRIC/FIN/Passport No./Corporation No of payor',
        key: 'budgetNricppPayor'
      },
      {
        label: 'Reason for 3rd Party payor',
        key: 'budget3rdPartyPayor'
      },
      {
        label: 'Relationship of payor to Client(s)',
        key: 'budgetPayorRelationship'
      },
      {
        label: 'Occupation/position of payor',
        key: 'budgetOccupationPayor'
      },
      {
        label: 'For which insurance product/investment account(s)',
        key: 'productAccount',
        options: this.productList
      }
    ]
  }

  get productList () {
    const prodList = []
    const prods = this.kycForm.allRecommendations.filter(
      rcmd => (rcmd.clientChoice === 'accept' || rcmd.clientChoice === 'ownchoice')
    )
    // The filtering is done this way so that in the NBR, we are able
    // to correctly list out the correct Product
    // There should be a better way of isolating the logic somewhere
    // so that it does not go everywhere. Currently it happens here and ClientDeclaration.vue
    prods.forEach((elem) => {
      if (elem.clientIndex === Number(this.selectedClient.split(' ').pop()) - 1) {
        prodList.push({ label: elem.productName, value: elem.referenceId })
      }
    })

    prodList.unshift({ label: '', value: '' })
    return prodList
  }
}
